import { Box, Fab, Tooltip } from '@mui/material';
import { Assessment, Notifications } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const QuickActionFABs = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{
      position: 'fixed',
      bottom: { xs: 16, sm: 24 },
      right: { xs: 16, sm: 24 },
      display: 'flex', flexDirection: 'column', gap: 1,
    }}>
      <Tooltip title="신청서 관리" placement="left">
        <Fab
          size="medium" color="primary"
          onClick={() => navigate('/admin/orders')}
          sx={{ '&:hover': { transform: 'scale(1.1)' }, transition: 'transform 0.2s ease' }}
        >
          <Assessment />
        </Fab>
      </Tooltip>
      <Tooltip title="알림 관리" placement="left">
        <Fab
          size="medium" color="secondary"
          onClick={() => navigate('/admin/alerts')}
          sx={{ '&:hover': { transform: 'scale(1.1)' }, transition: 'transform 0.2s ease' }}
        >
          <Notifications />
        </Fab>
      </Tooltip>
    </Box>
  );
};

export default QuickActionFABs;
